/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Type_Building_PermitInputs */

const en_doc_type_building_permit = /** @type {(inputs: Doc_Type_Building_PermitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Building Permit`)
};

const id_doc_type_building_permit = /** @type {(inputs: Doc_Type_Building_PermitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izin Mendirikan Bangunan (IMB)`)
};

/** @type {(inputs: Doc_Type_Building_PermitInputs) => LocalizedString} */
const es_doc_type_building_permit = en_doc_type_building_permit;

/** @type {(inputs: Doc_Type_Building_PermitInputs) => LocalizedString} */
const fr_doc_type_building_permit = en_doc_type_building_permit;

/** @type {(inputs: Doc_Type_Building_PermitInputs) => LocalizedString} */
const de_doc_type_building_permit = en_doc_type_building_permit;

/** @type {(inputs: Doc_Type_Building_PermitInputs) => LocalizedString} */
const ja_doc_type_building_permit = en_doc_type_building_permit;

/** @type {(inputs: Doc_Type_Building_PermitInputs) => LocalizedString} */
const zh_doc_type_building_permit = en_doc_type_building_permit;

/** @type {(inputs: Doc_Type_Building_PermitInputs) => LocalizedString} */
const ar_doc_type_building_permit = en_doc_type_building_permit;

/** @type {(inputs: Doc_Type_Building_PermitInputs) => LocalizedString} */
const it_doc_type_building_permit = en_doc_type_building_permit;

/** @type {(inputs: Doc_Type_Building_PermitInputs) => LocalizedString} */
const ru_doc_type_building_permit = en_doc_type_building_permit;

/** @type {(inputs: Doc_Type_Building_PermitInputs) => LocalizedString} */
const pt_doc_type_building_permit = en_doc_type_building_permit;

/** @type {(inputs: Doc_Type_Building_PermitInputs) => LocalizedString} */
const ko_doc_type_building_permit = en_doc_type_building_permit;

/**
* | output |
* | --- |
* | "Building Permit" |
*
* @param {Doc_Type_Building_PermitInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const doc_type_building_permit = /** @type {((inputs?: Doc_Type_Building_PermitInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Type_Building_PermitInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_type_building_permit(inputs)
	if (locale === "es") return es_doc_type_building_permit(inputs)
	if (locale === "fr") return fr_doc_type_building_permit(inputs)
	if (locale === "de") return de_doc_type_building_permit(inputs)
	if (locale === "ja") return ja_doc_type_building_permit(inputs)
	if (locale === "zh") return zh_doc_type_building_permit(inputs)
	if (locale === "ar") return ar_doc_type_building_permit(inputs)
	if (locale === "id") return id_doc_type_building_permit(inputs)
	if (locale === "it") return it_doc_type_building_permit(inputs)
	if (locale === "ru") return ru_doc_type_building_permit(inputs)
	if (locale === "pt") return pt_doc_type_building_permit(inputs)
	return ko_doc_type_building_permit(inputs)
});